import type { GroupUserSearchRequest } from '@trukt/tms-api/GroupService';
import { createKey } from '../../createKey';

const keyHandler = createKey('group-user');

export const GroupUserServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<GroupUserSearchRequest>(),
};
